import { type ComponentProps } from "react";

const CreditcardIcon = (props: ComponentProps<"svg">) => {
  return (
    <svg
      width="21"
      height="17"
      viewBox="0 0 21 17"
      fill="CurrentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.85 0C19.59 0 21 1.427 21 3.188v10.625c0 1.705-1.324 3.097-2.988 3.183L17.85 17H3.15l-.162-.004C1.324 16.91 0 15.518 0 13.813V3.188C0 1.428 1.41 0 3.15 0zM2.1 7.438v6.375c0 .586.47 1.062 1.05 1.062h14.7c.58 0 1.05-.476 1.05-1.062V7.437zm1.05-5.313c-.58 0-1.05.476-1.05 1.063v2.125h16.8V3.188c0-.587-.47-1.063-1.05-1.063z"
      />
    </svg>
  );
};

CreditcardIcon.displayName = "CreditCardIcon";

export default CreditcardIcon;
